import { render } from "./PostListing.vue?vue&type=template&id=2b89d23e&scoped=true"
import script from "./PostListing.vue?vue&type=script&lang=js"
export * from "./PostListing.vue?vue&type=script&lang=js"

import "./PostListing.vue?vue&type=style&index=0&id=2b89d23e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b89d23e"]])

export default __exports__